import { render } from "./CustomTax.vue?vue&type=template&id=638a8920&scoped=true"
import script from "./CustomTax.vue?vue&type=script&lang=js"
export * from "./CustomTax.vue?vue&type=script&lang=js"

import "./CustomTax.vue?vue&type=style&index=0&id=638a8920&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638a8920"]])

export default __exports__